module.exports = __webpack_public_path__ + "img/offer-count-bg.45bd115d.svg";